import { CardButton, Icon, Typography } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
var LoginButton = function (_a) {
    var provider = _a.provider, eventId = _a.eventId, onClick = _a.onClick, dataTestId = _a["data-testid"], type = _a.type;
    var getLocalizedString = useGetLocalizedString();
    var title = useMemo(function () {
        return type === 'pii'
            ? getLocalizedString('LOGIN_USING_PII')
            : getLocalizedString('LOGIN_USING_CREDENTIALS_BTN_TITLE');
    }, [getLocalizedString, type]);
    var subtitle = useMemo(function () {
        return type === 'pii'
            ? getLocalizedString('NAME_BIRTH_DATE_SSN')
            : getLocalizedString('USERNAME_AND_PASSWORD');
    }, [getLocalizedString, type]);
    var icon = useMemo(function () { return (React.createElement(Icon, { icon: type === 'pii' ? 'fingerPrint' : 'passwordLock', size: 25, color: {
            type: 'theme',
            colorLegacy: 'Primary/50',
            colorNext: 'brand/default',
            opacityLegacy: 0.5,
            opacityNext: 0.5,
        }, 
        // Removes the extra bottom margin when wrapped around a container div, so
        // that it's consistent with the dots loader which doesn't have any margin.
        sx: { display: 'block' } })); }, [type]);
    // Apply an accessible name to the button container. Since the label (platform name)
    // is already present on the DOM, use `aria-labelledby` instead of `aria-label`.
    var labelId = "LoginButton-platform-".concat(provider.id);
    return (React.createElement(CardButton, { "data-testid": dataTestId, onClick: function () { return onClick(provider); }, sx: { marginTop: '8px', padding: '10px' }, eventId: eventId, "aria-labelledby": "label-".concat(labelId, " subtitle-").concat(labelId), wrapHtmlTag: "div" },
        React.createElement("span", { style: {
                paddingBottom: '8px',
                display: 'flex',
                justifyContent: 'center',
            } }, icon),
        React.createElement(Typography, { sx: { marginLeft: '8px', marginBottom: '5px', display: 'block' }, weight: "normal", variant: "label", align: "center", color: {
                type: 'theme',
                colorLegacy: 'Blue/50',
                colorNext: 'brand/default',
            }, id: "label-".concat(labelId), as: "span" }, title),
        React.createElement(Typography, { sx: { marginLeft: '8px', display: 'block' }, weight: "normal", variant: "caption", align: "center", id: "subtitle-".concat(labelId), as: "span" }, subtitle)));
};
export default LoginButton;
